export function UserInfo(){
  return(
    <section>User Info</section>
  )
}